import React from "react";
import { Route, Redirect } from "react-router-dom";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const setComponent = (props) => {
    const currentUser = localStorage.getItem("jws_token");
    if (currentUser) {
      return <Component {...props} />;
    }
    if (props?.location?.state?.surveyWithoutLogin) {
      return <Component {...props} />;
    }
    return <Redirect to="/survey/login" />;
  };
  return <Route {...rest} render={setComponent} />;
};

const FrontWebProtectedRoute = ({ component: Component, ...rest }) => {
  const setComponent = (props) => {
    const location = localStorage.getItem("location_id");

    if (location) {
      return <Component {...props} />;
    }
    return <Redirect to="/" />;
  };
  return <Route {...rest} render={setComponent} />;
};
export { ProtectedRoute, FrontWebProtectedRoute };
